// Simple date formatting utilities (replaces date-fns)

export const format = (date, formatStr) => {
  const d = new Date(date);
  
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const fullMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  
  const pad = (n) => n.toString().padStart(2, '0');
  
  const day = d.getDate();
  const month = d.getMonth();
  const year = d.getFullYear();
  const hours = d.getHours();
  const minutes = d.getMinutes();
  
  // Handle common format patterns
  switch (formatStr) {
    case 'MMM d, yyyy':
      return `${months[month]} ${day}, ${year}`;
    case 'MMM d, yyyy h:mm a':
      const h = hours % 12 || 12;
      const ampm = hours >= 12 ? 'PM' : 'AM';
      return `${months[month]} ${day}, ${year} ${h}:${pad(minutes)} ${ampm}`;
    case 'MMMM d, yyyy':
      return `${fullMonths[month]} ${day}, ${year}`;
    case 'yyyy-MM-dd':
      return `${year}-${pad(month + 1)}-${pad(day)}`;
    case 'PP':
      return `${months[month]} ${day}, ${year}`;
    case 'PPP':
      return `${fullMonths[month]} ${day}, ${year}`;
    case 'PPp':
      const hr = hours % 12 || 12;
      const ap = hours >= 12 ? 'PM' : 'AM';
      return `${months[month]} ${day}, ${year} at ${hr}:${pad(minutes)} ${ap}`;
    default:
      return d.toLocaleDateString();
  }
};

export const formatDistanceToNow = (date) => {
  const now = new Date();
  const d = new Date(date);
  const diffMs = now - d;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffYears > 0) return `${diffYears} year${diffYears > 1 ? 's' : ''} ago`;
  if (diffMonths > 0) return `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
  if (diffWeeks > 0) return `${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
  if (diffDays > 0) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  if (diffHours > 0) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffMins > 0) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
  return 'just now';
};

// Format currency in Dutch Euro locale (€1.234,56)
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
};
